import ChatsBrowser from "./chats-browser-route";

export default ChatsBrowser;
